export enum ScreenSizes {
    minimize,
    mediumScreen,
    fullScreen,
    splitScreen,
}
